module.exports = __webpack_public_path__ + "static/media/logo.ba0d4662.png";